module.exports = __webpack_public_path__ + "static/media/portfolio2.1ae3d4c0.png";